import { mapState, mapActions, mapMutations, mapGetters } from 'vuex';
import actions from './actions';
import state from './state';
import getters from './getters';
import mutations from './mutations';

export const serviceComputed = {
	...mapGetters('mesCalPvoStore', Object.keys(getters)),
	...mapState('mesCalPvoStore', Object.keys(state))
};
export const serviceMethods = {
	...mapActions('mesCalPvoStore', Object.keys(actions)),
	...mapMutations('mesCalPvoStore', Object.keys(mutations))
};
